import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    modalHeader: {
        display: "flex",
        alignItems: "center",
        padding: `${theme.spacing(4)} ${theme.spacing(6)}`,
        borderBottom: `1px solid ${theme.palette.border.select}`,
        fontSize: "18px",
        fontWeight: 400,
        fontFamily: "Open Sans",
        color: theme.palette.info.main,
    },
    modalBody: {
        padding: theme.spacing(6),
        display: "flex",
        flexDirection: "column",
    },
    modalBodyLeft: {
        display: "flex",
        flexDirection: "column",
    },
    modalBodyRight: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(5),
        width: "100%",
    },
    userImageWrapper: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: 120,
        height: 120,
        borderRadius: "100%",
        backgroundColor: theme.palette.graphs.main,
    },
    userImageIcon: {
        fontSize: "44px !important",
        color: theme.palette.primary.dark,
    },
    userImage: {
        width: 120,
        height: 120,
        borderRadius: "100%",
        objectFit: "cover" as "cover",
    },
    userImageActionWrapper: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginTop: theme.spacing(2),
    },
    userImageAction: {
        fontSize: "12px !important",
        fontWeight: `700 !important`,
    },
    textField: {
        width: "100%",

        "& .MuiOutlinedInput-root": {
            fontFamily: "Open Sans",
            fontSize: "16px",
            fontWeight: "400",
            "& .MuiOutlinedInput-input": {
                fontFamily: "Open Sans",
                fontSize: "16px",
                fontWeight: "400",
                padding: `${theme.spacing(2.5)} ${theme.spacing(3)} !important`,
            },
            "&.Mui-focused fieldset": {
                borderColor: theme.palette.info.main,
            },
        },
        "& .MuiInputLabel-outlined": {
            fontFamily: "Open Sans",
            fontSize: "16px",
            fontWeight: "400",
            "&.Mui-focused": {
                color: theme.palette.info.light,
            },
        },
    },
    formRow: {
        display: "flex",
        gap: theme.spacing(4),
    },
    boxContainer: {
        width: "100%",
    },
    formLabel: {
        "&.MuiTypography-root": {
            fontFamily: "Open Sans",
            fontWeight: 700,
            fontSize: "12px",
            textTransform: "uppercase",
            color: theme.palette.primary.dark,
        },
        "&.MuiFormLabel-root": {
            fontFamily: "Open Sans",
            fontWeight: 700,
            fontSize: "12px",
            textTransform: "uppercase",
            color: theme.palette.primary.dark,
        },
        "&.MuiFormLabel-root.Mui-focused": {
            color: theme.palette.primary.dark,
        },
    },
    section: {
        display: "flex",
        gap: theme.spacing(8),
        width: "100%",
        "& .MuiChip-root": {
            fontFamily: "Open Sans !important",
            fontSize: "12px !important",
            fontWeight: "700",
            color: theme.palette.primary.main,
            backgroundColor: theme.palette.info.main,
        },
    },
    divider: {
        marginTop: `${theme.spacing(6)} !important`,
        marginBottom: `${theme.spacing(6)} !important`,
    },
    select: {
        "& .MuiInputBase-input": {
            fontFamily: "Open Sans",
            fontSize: "14px",
            fontWeight: "400",
            padding: `${theme.spacing(2.5)} ${theme.spacing(3)} !important`,
            color: `${theme.palette.text.secondary} !important`,
        },
        "& .Mui-disabled": {
            "& .MuiChip-root": {
                backgroundColor: `${theme.palette.border.select} !important`,
                color: `${theme.palette.text.secondary} !important`,
            },
        },
    },
    footer: {
        borderTop: `1px solid ${theme.palette.border.select}`,
        display: "flex",
        padding: `${theme.spacing(4)} ${theme.spacing(6)}`,
        gap: theme.spacing(4),
        justifyContent: "flex-end",
    },
    button: {
        "&.MuiButton-root": {
            fontFamily: "Open Sans !important",
            fontSize: "12px !important",
            fontWeight: "700 !important",
            color: `${theme.palette.primary.dark} !important`,
        },
    },
    submitButton: {
        "&.MuiButton-root": {
            fontFamily: "Open Sans !important",
            fontSize: "12px !important",
            fontWeight: "700 !important",
        },
    },
    sectionContent: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(4),
    },
}));

export const modalStyles = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "792px",
    maxHeight: "calc(100vh - 32px)",
    overflowY: "auto",
    bgcolor: "background.paper",
    borderRadius: "4px",
};
